import { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import client from "../api/client";


function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUnverified, setIsUnverified] = useState(false);
  const [successMessage, setSuccessMessage] = useState(location.state?.message || "");
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem("hasSeenWelcome");
    if (!seen) {
      navigate("/welcome");
    }
  }, []);

  /*useEffect(() => {
    if (location.state?.message) {
      window.history.replaceState({}, document.title);
    }
  }, []);*/
  useEffect(() => {
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
    }
  }, [location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsUnverified(false);
    setIsSubmitting(true);

    /*try {
      const res = await client.post("/login", { email, password });
      login(res.data);
      navigate("/");
    } catch (err) {
      setError("Invalid email or password.");
    } finally {
      setIsSubmitting(false);
    }
  };*/

  try {
    const res = await client.post("/login", { email, password, rememberMe });
    login(res.data);
    navigate("/");
  } catch (err) {
  if (!err.response) {
    setError("Unable to connect.");
  } else if (err.response.status === 500) {
    setError("Something went wrong. Please try again.");
  } else if (err.response.status === 403) {
    setError(err.response.data.error);
    setIsUnverified(true);
  } else {
    setError("Invalid email or password.");
  }
} finally {
    setIsSubmitting(false);
  }
};
  return (
    <main className="AuthPage">
      <h2>Log In</h2>

      {location.state?.message && (
        <p className="success">{location.state.message}</p>
      )}

      {error && (
        <p className="error">
          {error}
          {isUnverified && (
            <>
              {" "}<Link to="/resend-verification">Resend verification email</Link>
            </>
          )}
        </p>
      )}

      <form onSubmit={handleSubmit}>
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        <div style={{ width: "100%", alignSelf: "stretch", marginBottom: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "8px" }}>
            <input
              id="rememberMe"
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              style={{
                width: "auto",
                margin: 0,
                flexShrink: 0,
                display: "inline-block",
              }}
            />
              <label htmlFor="rememberMe" style={{ margin: 0, width: "auto", textAlign: "left" }}>
                Remember me
              </label>
          </div>
        </div>

        <button type="submit" disabled={isSubmitting} style={{ marginTop: "16px", marginRight: "22px" }}>
          {isSubmitting ? "Logging in..." : "Log In"}
        </button> 
        
         Don't have an account? <Link to="/register">Create one</Link>
      </form>
      <p style={{ marginTop: "16px" }}>
        <Link to="/forgot-password">Forgot your password?</Link>
      </p>
    </main>
  );
  
}

export default LoginPage;